// @flow

import * as React from 'react';

import SocialLabel from './SocialLabel';

type Props = {
  socialLabelText?: string,
  label: string | React.Element<typeof SocialLabel>,
  isActive?: boolean,

  /** A click event handler */
  onClick?: Function,
};

const SocialTab = ({ socialLabelText, label, isActive, onClick }: Props) => (
  <li>
    <a
      className={isActive ? 'ui_tab active' : 'ui_tab'}
      onClick={onClick}
      data-tab-name={!socialLabelText ? label : socialLabelText}
    >
      {label}
    </a>
  </li>
);

SocialTab.defaultProps = {
  socialLabelText: undefined,
  isActive: false,
  onClick: () => {},
};

export default SocialTab;
